import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/** Shown before sign-in, and for any account whose tenant has no display name. */
export const DEFAULT_FOOTER_OWNER = 'Appable Technologies Private Limited';

/**
 * The one footer every page ends on, whatever the role: the signed-in tenant's
 * own copyright on the left, attribution on the right. Kept in one component so
 * the two never drift apart between the signed-in shell and the login screen.
 *
 * The tenant is read from the auth context rather than passed in — every page
 * that renders this already sits inside the provider, including /login, where
 * there is no tenant yet and the default stands in.
 */
const AppFooter = ({ className = '' }) => {
  const { user } = useAuth();
  const owner = String(user?.tenantName || user?.tenantSlug || '').trim() || DEFAULT_FOOTER_OWNER;

  return (
    <div
      className={`flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-xs text-muted-foreground ${className}`}
    >
      <span>{new Date().getFullYear()} - {owner}. All rights reserved.</span>
      <span className="font-medium">Powered by Appable</span>
    </div>
  );
};

export default AppFooter;
